import { PreprocessorUtils, dataflowLexerWoAnno } from './dataflow-preprocessor-utils';
import { ScopedPreprocessors } from './dataflow-scoped-preprocessor';

export class DataflowPreprocessor extends ScopedPreprocessors {

	constructor(script: string) {
		super(script);
	}

	protected enrollScopedProcessors(): void {
		this.enrollGroupProcessor();
		this.enrollMetaFunctionProcessor();	// To resolve the ambiguous between basicfunction and metafunction
		this.enrollArgumentProcessor();		// To resolve the ambiguous between expression and metaassignment
	}

	private enrollGroupProcessor(): void {
		// transformationGroup := transformName AT groupName
		this.enrollOneProcessor(dataflowLexerWoAnno.AT, () => {
			this.getLastToken().head.push(PreprocessorUtils.annotationName.implyGroup);
		});
	}

	private enrollMetaFunctionProcessor(): void {
		// Find the assignment and metaAssignment in metafunction
		this.enrollOneProcessor(dataflowLexerWoAnno.ASSIGN, () => {
			// We only care about ASSIGNs appears in scopes starting with '('
			// Unfortunately, assignment in transformation also fit this rule, so I also add the annotation there.
			if (this.tokenList[this.currentScopeItem.scopeIndex].type === dataflowLexerWoAnno.OPEN_PAREN) {
				// -1 means the annotation is added to the front of function name(while 0 means before '(')
				this.currentScopeItem.scopeTags.set(PreprocessorUtils.annotationName.implyMetafunction, -1);
			}
		});
	}

	private enrollArgumentProcessor(): void {
		// Mark the transientAssignment
		this.enrollOneProcessor(dataflowLexerWoAnno.TRANSIENT_ASSIGN, () => {
			// transientAssignment only appears in transientAssignment := TRANSIENT_ASSIGN expression
			this.currentScopeItem.itemTags.set(PreprocessorUtils.annotationName.implyTransientAssignment, 0);
		});
		// Mark the configuration
		this.enrollOneProcessor(dataflowLexerWoAnno.COLON, () => {
			// We only care about COLONs appears in scopes starting with '('
			if (this.tokenList[this.currentScopeItem.scopeIndex].type === dataflowLexerWoAnno.OPEN_PAREN) {
				// For configuration := configName COLON expression
				// However, there is also a transientOperand := COLON name, but transientOperand only appears in expression := transientOperand
				// We can also find that expression cannot follow OPEN_PAREN configName, so there isn't an ambiguous
				if (
					this.currentScopeItem.itemIndex + 1 === this.tokenList.length &&
					PreprocessorUtils.isBasicName(this.tokenList[this.currentScopeItem.itemIndex])
				) {
					this.currentScopeItem.itemTags.set(PreprocessorUtils.annotationName.implyConfiguration, 0);
				}
			}
		});
	}
}
